<template>
	<AsiCardDetail :icon="icons.trimmingCostThreshold" :title="$t('globalConfig.terms.bulkOfferThreshold')"
	               :show-action-button="!readonly" @actionButtonClicked="updateDialog.open()">
		<AsiCardDetailEntry :label="$t('globalConfig.terms.bulkOfferThresholdMeters')"
		                    :icon="icons.trimmingCostThreshold" :value="globalConfig.bulkOfferThresholdMeters">
			<template v-slot:default v-if="globalConfig.bulkOfferThresholdMeters !== null">
				{{ globalConfig.bulkOfferThresholdMeters }} {{ $t('constants.unitMeter') }}
			</template>
		</AsiCardDetailEntry>

		<GlobalConfigUpdateDialogBulkOfferThreshold v-if="!readonly && updateDialog.isLoaded"
		                                           :open="updateDialog.isOpen"
		                                           :global-config="globalConfig"
		                                           @cancel="updateDialog.close()"
		                                           @save="updateDialog.close(); change();"/>
	</AsiCardDetail>
</template>

<script lang="ts">
	import Vue from 'vue';
	import {Component, Emit, Prop} from 'vue-property-decorator';
	import Icon from "@/plugins/icons";
	import AsiCardDetail from "@/components/common/AsiCardDetail.vue";
	import AsiCardDetailEntry from "@/components/common/AsiCardDetailEntry.vue";
	import {IGlobalConfigAdmin} from "@/models/global-config/GlobalConfigAdminModels";
	import DialogHandler from "@/components/common/DialogHandler";
	import GlobalConfigUpdateDialogBulkOfferThreshold
		from "@/components/global-config/admin/GlobalConfigUpdateDialogBulkOfferThreshold.vue";

	@Component({
		components: {GlobalConfigUpdateDialogBulkOfferThreshold, AsiCardDetailEntry, AsiCardDetail}
	})
	export default class GlobalConfigCardBulkOfferThreshold extends Vue {

		@Prop({type: Object, required: true})
		public globalConfig!: IGlobalConfigAdmin;

		@Prop({type: Boolean, default: false})
		public readonly!: boolean;

		private icons = Icon;
		private updateDialog: DialogHandler = new DialogHandler();

		@Emit('change')
		public change(): void {
			return;
		}

	}
</script>
